<template>
  <div class="product" :id="list.id">
    <div class="product-mainimg">
      <img :src="'images/' + list.id + '/' + list.mainimg" />
    </div>
    <div class="product-tx">
      <span class="status sale" v-if="list.status == 1">見学受付中</span>
      <span class="status sold" v-else-if="list.status == 0">売約済</span>
      <span class="status const" v-else-if="list.status == 2">建設中</span>
      <h3>{{ list.name }}</h3>
      <p class="address">{{ list.address }}</p>
      <div class="product-tx-label">
        <p v-if="list.spprice" class="spprice">{{ list.spprice }}</p>
        <p v-else-if="list.price == ''" class="price_ask">
          お問い合わせください
        </p>
        <p v-else class="price">{{ list.price }}</p>
        <ul>
          <li>
            <span>間取</span>
            <p class="madori">{{ list.madori }}</p>
          </li>
          <li>
            <span>建物</span>
            <p class="tatemono">{{ list.tatemono }}</p>
          </li>
          <li>
            <span>土地</span>
            <p class="tochi">{{ list.tochi }}</p>
          </li>
        </ul>
      </div>
      <h4 class="maincopy">{{ list.maincopy }}</h4>
      <p class="point" v-html="list.contents"></p>
      <div class="producttab">
        <ProductTab :Tabid="id" :Tablocate="locate" />
      </div>
    </div>
  </div>
</template>

<script>
import ProductTab from "@/components/CpProductTab.vue";
export default {
  data() {
    return {};
  },
  components: {
    ProductTab,
  },
  props: ["id", "locate"],
  computed: {
    list() {
      let list = this.$alllist[this.locate][this.id];
      return list;
    },
    status() {
      let statustext;
      if (this.list.status == 1) {
        statustext = "販売中";
      } else if (this.list.status == 0) {
        statustext = "売約済";
      } else if (this.list.status == 2) {
        statustext = "建設中";
      }
      return statustext;
    },
  },
};
</script>
<style lang="scss" scoped>
.product {
  padding-top: $v-gap;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: calc($h-gap/2);
  position: relative;
  &::after {
    content: "";
    display: block;
    position: absolute;
    width: 80%;
    height: 50%;
    right: 0;
    bottom: -2rem;
    background: linear-gradient(#fff, #f6f6f6);
    z-index: -1;
    border-radius: 2rem 0 0 2rem;
    @include tb {
      display: none;
    }
  }
  @include tb {
    grid-template-columns: 1fr;
    grid-gap: 2rem;
  }
  .product-mainimg {
    border-radius: 0 $h-gap $h-gap 0;
    overflow: hidden;
    aspect-ratio: 3/2;
    @include tb {
      margin-right: $h-gap;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .product-tx {
    padding-right: $h-gap;
    flex-grow: 0;
    overflow: hidden;
    position: relative;

    @include tb {
      padding: 0 $h-gap;
    }
    .status {
      line-height: 2.5rem;
      display: inline-block;
      font-weight: bold;
      font-size: clamp(1rem, 1.2vw, 1.2rem);
      color: white;
      padding: 0 1em;
      margin-bottom: 1.5rem;
      &.sale {
        background-color: $color_red;
      }
      &.sold {
        background-color: $color-gray;
      }
      &.const {
        background-color: $color_blue;
      }
    }
    h3 {
      font-size: 2rem;
      font-weight: bold;
      padding-bottom: 0.5rem;
    }
    .address {
      font-size: 0.8rem;
      padding-bottom: 1.5rem;
    }
    .price,
    .spprice {
      font-size: 2.5rem;
      font-weight: bold;
      color: $color_red;
      line-height: 0.9em;
      flex-shrink: 0;

      &::after {
        content: "万円";
        color: $color_red;
        font-size: 1rem;
        margin-left: 0.5em;
        vertical-align: middle;
      }
      span {
        font-size: 1rem;
      }
    }
    .price {
      &::before {
        content: "販売価格";
        color: $fontcolor;
        font-size: 1rem;
        margin-right: 0.5em;
        vertical-align: middle;
      }
    }
    .spprice {
      &::before {
        content: "特別価格";
        color: $color-red;
        font-size: 1rem;
        margin-right: 0.5em;
        vertical-align: middle;
      }
    }
    .price_ask {
      font-size: 1.5rem;
      font-weight: bold;
      color: $color_red;
      line-height: 0.9em;
      flex-shrink: 0;

      &::before {
        content: "販売価格";
        color: $fontcolor;
        font-size: 1rem;
        margin-right: 0.5em;
        vertical-align: middle;
      }
      span {
        font-size: 1rem;
      }
    }
    .maincopy {
      font-size: 1.2rem;
      font-weight: bold;
      color: $color_red;
      margin-bottom: 0.5em;
    }
    .point {
      line-height: 1.5;
      a {
        display: block;
        background-color: aqua;
        color: red;
      }
    }
    .product-tx-label {
      display: flex;
      align-items: center;
      border-top: 1px solid $color_sub;
      padding-top: 1.5rem;
      padding-bottom: 1.5rem;
      @include tb {
        padding-bottom: 2rem;
        flex-direction: column;
        align-items: flex-start;
      }
      ul {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 0.25em;
        margin-left: auto;
        @include tb {
          margin-left: 0;
          margin-top: 0.5rem;
        }
        @include sp {
          width: 100%;
        }
        li {
          text-align: center;
          border: 1px solid $color_sub;
          border-radius: 0.2em;
          padding: 0.5em 0.5em 0.25em 0.5em;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          font-size: 0.8rem;

          span {
            font-weight: bold;
            letter-spacing: 0.5em;
            text-indent: 0.5em;
            margin-bottom: 0.5em;
          }
          .madori,
          .tochi,
          .tatemono {
            font-size: 1.25rem;
            font-weight: 600;
            line-height: 0.9em;

            &::after {
              font-weight: normal;
              font-size: 0.8rem;
            }
          }
          .tochi::after,
          .tatemono::after {
            content: "坪";
          }
        }
      }
    }
  }
}
</style>
